import React, { useState, useEffect } from "react";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import Swal from "sweetalert2";
import { FaRegEdit } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";

function EditEnquiry(props) {
  const [editData, setEditData] = useState({
    companyname: "",
    contactperson: "",
    contactnumber: "",
    officeaddress: "",
    siteaddress: "",
    natureofbusiness: "",
    emailid: "",
    state: "",
    city: "",
    pincode: "",
    gstnumber: "",
    leadtypeid: "",
  });
  const [statedata, setStateData] = useState([]);
  const [NatureOfBusiness, setNatureOfBusiness] = useState([]);
  const [enquiryEdit, setEnquiryEdit] = useState([]);
  const [CityOptions, setCityOptions] = useState([]);
  const [DgRatings, setDgRatings] = useState([]);
  const [PanelTypeOptions, setPanelTypeOptions] = useState([]);
  const [LeadTypeOptions, setLeadTypeOptions] = useState([]);

  useEffect(() => {
    if (props.leadTypeID === 1 && editData.agentid && editData.typeofenquiry) {
      GetRatings();
    }
  }, [editData.agentid, editData.typeofenquiry]);

  useEffect(() => {
    if (props.leadTypeID === 1 && editData.agentid && editData.rating) {
      paneltype();
    }
  }, [editData.rating]);

  const fetchEdit = async (enquiryID) => {
    let obj = {
      query: `[dbo].[CRM_Proc_EditModal_GetData]@EnquiryID='{0}'`,
      queryArr: [`${enquiryID}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log(resp, "edit resp");
      const data = resp[""]?.[0] || {};
      setEditData(data);
      setStateData(resp?.states);
      setNatureOfBusiness(resp?.natureofbusiness);
      setLeadTypeOptions(resp?.leadtypes);
      const enquiryList = resp?.typeofenquirys || [];
      console.log(enquiryList, "enquiryList data");
      setEnquiryEdit(enquiryList);
    } catch (err) {
      console.error("Error fetching row details:", err);
    }
  };

  useEffect(() => {
    if (props.isOpen) {
      fetchEdit(props.enquiryID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen]);

  const stateUpdate = (selectedState) => {
    let obj = {
      query: `[dbo].[CRM_Proc_CustomerEnquiry_State_OnChange]@AgentID='{0}',@State='{1}'`,
      queryArr: [`${editData.agentid}`, `${selectedState}`],
    };
    console.log("Fetching cities for:", selectedState);
    Hexapi(obj)
      .then((resp) => {
        console.log("Response State:", resp);
        if (resp && resp.cities) {
          setCityOptions(resp.cities);
        } else {
          setCityOptions([]);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const GetRatings = () => {
    let obj = {
      query: `[dbo].[CRM_Proc_CustomerEnquiry_TypeOfEnquiry_OnChange]@AgentID='{0}',@TypeOfEnquiry='{1}'`,
      queryArr: [`${editData.agentid}`, `${editData.typeofenquiry}`],
    };
    Hexapi(obj)
      .then((resp) => {
        console.log("Response for type Enquiry:", resp);
        if (resp && resp.ratings) {
          setDgRatings(resp.ratings);
        } else {
          setDgRatings([]);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const paneltype = () => {
    let obj = {
      query: `[dbo].[CRM_Proc_CustomerEnquiry_Rating_OnChange]@AgentID='{0}',@Rating='{1}'`,
      queryArr: [`${editData.agentid}`, `${editData.rating}`],
    };
    Hexapi(obj)
      .then((resp) => {
        console.log("DG Rating:", resp);
        if (Array.isArray(resp.panels)) {
          setPanelTypeOptions(resp.panels.map((p) => p.panel));
        } else {
          setPanelTypeOptions([]);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleEditSubmit = async () => {
    let obj = {
      query: `[dbo].[CRM_Proc_EditModal_Submit]@EnquiryID='{0}',@CompanyName='{1}',@CustomerName='{2}',@ContactNumber='{3}',@officeAddress='{4}',@SiteAddress='{5}',@NatureofBusiness='{6}',@Rating='{7}',@EmailID='{8}',@City='{9}',@State='{10}',@Pincode='{11}',@TypeofEnquiry='{12}',@OtherSpecifications='{13}',@AgentID='{14}',@Panel='{15}',@Qty='{16}',@LeadTypeID='{17}',@GSTNumber='{18}'`,
      queryArr: [
        `${props.enquiryID}`,
        `${editData.companyname}`,
        `${editData.customername}`,
        `${editData.contactnumber}`,
        `${editData.officeaddress}`,
        `${editData.siteaddress}`,
        `${editData.natureofbusiness}`,
        `${editData.rating}`,
        `${editData.emailid}`,
        `${editData.city}`,
        `${editData.state}`,
        `${Number(editData.pincode)}`,
        `${editData.typeofenquiry}`,
        `${editData.otherspecifications}`,
        `${editData.agentid}`,
        `${editData.panel}`,
        `${editData.qty}`,
        `${editData.leadtypeid}`,
        `${editData.gstnumber}`,
      ],
    };
    try {
      const resp = await Hexapi(obj);
      console.log("Row details:", resp);
      if (resp[""] && resp[""][0]) {
        const { command, msg, customerid } = resp[""][0];
        if (command === 0) {
          Swal.fire({
            icon: "error",
            title: "Operation Failed",
            text: `${msg}`,
          });
        } else if (command === 1) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${msg}`,
          }).then(() => {
            props.onClose?.();
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
    console.log("Submit edited data:", editData);
  };

  return (
    <>
      <FaRegEdit
        style={{ cursor: "pointer", fontSize: "25px" }}
        title="Edit"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.onOpen?.();
          fetchEdit(props.enquiryID);
        }}
      />
      <Modal
        show={props.isOpen}
        onHide={() => props.onClose?.()}
        dialogClassName="custom-modall-edit"
        backdrop="static"
        style={{ zIndex: 2000 }}
        size="xl"
        scrollable
      >
        {/* Header */}
        <Modal.Header closeButton className="bg-white text-black">
          <div className="w-100">
            <div className="fw-bold">Edit Lead</div>
            <div className="d-flex gap-3 mt-1 small">
              <span>RecID: {props.enquiryID}</span>
              <span>Customer: {props.customerName}</span>
            </div>
          </div>
        </Modal.Header>

        {/* Body */}
        <Modal.Body
          className="px-5"
          style={{ maxHeight: "75vh", overflowY: "auto" }}
        >
          {/* Agent Name */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <label className="form-label small fw-semibold text-start d-block">
                Agent
              </label>
              <input
                type="text"
                className="form-select"
                style={{ cursor: "not-allowed" }}
                value={editData.agentname || ""}
                disabled
              />
            </div>
            <div className="col-lg-3 col-md-6">
              <label className="form-label small fw-semibold text-start d-block">
                Lead Type
              </label>
              <select
                className="form-select"
                value={editData.leadtypeid || ""}
                onChange={(e) =>
                  setEditData({ ...editData, leadtypeid: e.target.value })
                }
              >
                <option value="">Select Lead Type</option>
                {LeadTypeOptions.map((l, i) => (
                  <option key={i} value={l.leadtypeid}>
                    {l.leadtype}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* CUSTOMER DETAILS */}
          <div className="bg-white rounded shadow-sm border p-4 mb-4">
            <h6 className="fw-bold mb-3 text-start">Customer Details</h6>

            <div className="row g-3">
              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Company Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Company Name"
                  value={editData.companyname || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, companyname: e.target.value })
                  }
                />
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Customer Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Customer Name"
                  value={editData.customername || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, customername: e.target.value })
                  }
                />
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Contact Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Contact Number"
                  value={editData.contactnumber || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      contactnumber: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Email ID
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter Email ID"
                  value={editData.emailid || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, emailid: e.target.value })
                  }
                />
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Office Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Office Address"
                  value={editData.officeaddress || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      officeaddress: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Site Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Site Address"
                  value={editData.siteaddress || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, siteaddress: e.target.value })
                  }
                />
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Nature Of Business
                </label>
                <select
                  className="form-select"
                  value={editData.natureofbusiness?.toLowerCase() || ""}
                  onChange={(e) => {
                    setEditData({
                      ...editData,
                      natureofbusiness: e.target.value,
                    });
                  }}
                >
                  <option value="">Select Nature Of Business</option>
                  {NatureOfBusiness.map((NatureOfBusinessObj, idx) => (
                    <option
                      key={idx}
                      value={NatureOfBusinessObj.natureofbusiness.toLowerCase()}
                    >
                      {NatureOfBusinessObj.natureofbusiness}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  State
                </label>
                <select
                  className="form-select"
                  value={editData.state?.toLowerCase() || ""}
                  onChange={(e) => {
                    const newState = e.target.value;
                    setEditData({
                      ...editData,
                      state: newState,
                      city: "Select City",
                    });
                    stateUpdate(newState);
                  }}
                >
                  <option value="">Select State</option>
                  {statedata.map((stateObj, idx) => (
                    <option key={idx} value={stateObj.state.toLowerCase()}>
                      {stateObj.state}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  City
                </label>
                <select
                  className="form-select"
                  value={editData.city || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, city: e.target.value })
                  }
                  disabled={!editData.state}
                >
                  <option value={editData.city}>{editData.city}</option>
                  {CityOptions.map((cityObj, idx) => (
                    <option key={idx} value={cityObj.city}>
                      {cityObj.city}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Pincode
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Pincode"
                  value={editData.pincode || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, pincode: e.target.value })
                  }
                />
              </div>
              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  GST Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter GST Number"
                  value={editData.gstnumber || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, gstnumber: e.target.value })
                  }
                />
              </div>
            </div>
          </div>

          {/* CUSTOMER ENQUIRY */}
          <div className="bg-white rounded shadow-sm border p-4 mb-3">
            <h6 className="fw-bold mb-3 text-start">Customer Enquiry</h6>

            <div className="row g-3">
              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Type of Enquiry
                </label>
                <select
                  className="form-select"
                  value={editData.typeofenquiry?.trim() || ""}
                  onChange={(e) => {
                    setEditData({
                      ...editData,
                      typeofenquiry: e.target.value,
                    });
                  }}
                  disabled
                >
                  <option value="">Select Enquiry Type</option>
                  {enquiryEdit.map((enquiry, idx) => (
                    <option key={idx} value={enquiry.typeofenquiry}>
                      {enquiry.typeofenquiry}
                    </option>
                  ))}
                </select>
              </div>

              {props.leadTypeID === 1 && (
                <>
                  <div className="col-lg-3 col-md-6">
                    <label className="form-label small fw-semibold text-start d-block">
                      DG Rating
                    </label>
                    <select
                      className="form-select"
                      value={editData.rating || ""}
                      onChange={(e) => {
                        const selectedRating = e.target.value;
                        setEditData({
                          ...editData,
                          rating: e.target.value,
                        });
                        GetRatings();
                        paneltype(selectedRating);
                      }}
                    >
                      <option value="">Select DG Rating</option>
                      {DgRatings.map((enquiry, idx) => (
                        <option key={idx} value={enquiry.rating}>
                          {enquiry.rating}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <label className="form-label small fw-semibold text-start d-block">
                      Panel Type
                    </label>
                    <select
                      className="form-select"
                      value={editData.panel || ""}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          panel: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Panel Type</option>
                      {PanelTypeOptions.map((panel, idx) => (
                        <option key={idx} value={panel}>
                          {panel}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}

              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Quantity
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Quantity"
                  value={editData.qty ?? ""}
                  onChange={(e) =>
                    setEditData({ ...editData, qty: e.target.value })
                  }
                />
              </div>

              <div className="col-12">
                <label className="form-label small fw-semibold text-start d-block">
                  Other Specifications
                </label>
                <textarea
                  className="form-control"
                  placeholder="Other Specifications"
                  rows="2"
                  value={editData.otherspecifications || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      otherspecifications: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="d-flex justify-content-center mt-4">
            <IconButton
              onClick={() => handleEditSubmit()}
              sx={{
                px: 6,
                py: 1,
                borderRadius: "999px",
                backgroundColor: "#000",
                color: "#fff",
                fontWeight: 600,
                fontSize: "16px",
                "&:hover": { backgroundColor: "#111" },
              }}
            >
              Submit
            </IconButton>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default EditEnquiry;
